import type { PatSnapCommonResponseData } from '@patsnap/tahiti-core/common/ps-http';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { PsHttpService } from '@patsnap/tahiti-core/common/ps-http';

export interface PatentBatchImagesResponse {
    [key: string]: {
        url: string
        url_120: string
    }
}

export interface PatentIdImageId {
    patent_id: string
    image_id: string
}

export interface IPImageSearchPatentApi {
    // 老接口：只传 patent_ids
    patentBatchImages: (patent_ids: string[]) => Promise<PatentBatchImagesResponse>
    // 新接口：传 patent_id 和 image_id
    patentBatchImagesByImageId: (patent_id_image_ids: PatentIdImageId[]) => Promise<PatentBatchImagesResponse>
}

export const IPImageSearchPatentApi = Symbol('IPImageSearchPatentApi');

@injectable()
export class IPImageSearchPatentApiImpl extends PsHttpService implements IPImageSearchPatentApi {
    get options() {
        return {
            baseURL: `${import.meta.env.VITE_CORE_SEARCH_SERVICE_URI}/core-telecom-api/telecom`,
        }
    }

    // 老接口实现
    patentBatchImages(patent_ids: string[]) {
        return this.post<PatSnapCommonResponseData<PatentBatchImagesResponse>>({
            url: '/patent/batch-images',
            cache: true,
            data: {
                patent_ids,
            },
        })
            .then((res) => {
                return res?.data as unknown as PatentBatchImagesResponse;
            })
    }

    // 新接口实现
    patentBatchImagesByImageId(patent_id_image_ids: PatentIdImageId[]) {
        return this.post<PatSnapCommonResponseData<PatentBatchImagesResponse>>({
            url: '/patent/image-id/batch-images',
            cache: true,
            data: {
                patent_id_image_ids,
            },
        })
            .then((res) => {
                return res?.data as unknown as PatentBatchImagesResponse;
            })
    }
}
